"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectPromotor = void 0;
const tslib_1 = require("tslib");
function connectPromotor(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { signalData, promotorAddress } = options || {};
        // complete the webRTC connection
        this.connect({ signalData, peerAddress: promotorAddress });
    });
}
exports.connectPromotor = connectPromotor;
//# sourceMappingURL=connectPromotor.js.map